import { render, staticRenderFns } from "./collection-record.vue?vue&type=template&id=f3005cec&scoped=true"
import script from "./collection-record.vue?vue&type=script&lang=js"
export * from "./collection-record.vue?vue&type=script&lang=js"
import style0 from "./collection-record.vue?vue&type=style&index=0&id=f3005cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3005cec",
  null
  
)

export default component.exports